import { imgV2 as img } from '@styles/utils';
import { IProduct } from '@interfaces';

import styles from '@components/common/products/product.styles';

export default function ProductStandard({ product }: { product?: IProduct }) {
    return (
        <div className={styles.standard}>
            <h3>us vs them</h3>
            <h2>the cerebelly standard</h2>
            <p>
                At Cerebelly we think parents should use nutrition levels to decide
                what to feed their kids, so we list all the nutrients our foods contain.
                Other brands may not do that (so a blank square above may be a 0% or it
                may be “undisclosed”), but if they have it, we think they should list
                their actual nutrition!
            </p>
            <div className="cerebelly-labels">
                <div>
                    <div>
                        <img src={img('pdp2/claim-badges/CLPA.svg')} alt="" />
                    </div>
                    <div>
                        <span className="heading">clean label certified</span>
                    </div>
                </div>
                <div>
                    <div>
                        <img src={img('pdp2/claim-badges/USDA.svg')} alt="" />
                    </div>
                    <div>
                        <span className="heading">organic</span>
                    </div>
                </div>
                <div className="product-nutrients">
                    <div>
                        <span className="number">16</span>
                    </div>
                    <div>
                        <span className="heading">brain-supporting nutrients</span>
                    </div>
                </div>
                <div className="product-sugar">
                    <div>
                        <span className="number">
                            0
                            {/* this span is comment because on the pdf isnt displayed but in figma it is */}
                            <span className="grams">g</span>
                        </span>
                    </div>
                    <div>
                        <span className="heading">added sugar</span>
                    </div>
                </div>
                <div className="product-ready">
                    <div>
                        <img src={img('homepage3/us-vs-them/Veggie.svg')} alt="Vegie" />
                    </div>
                    <div>
                        <span className="heading">veggie-first</span>
                    </div>
                </div>
            </div>
            {/*
                <button className="button blue v2">lorem ipsum</button>
            */}
        </div>
    );
}
